import { render, staticRenderFns } from "./constructionRelactionTaskSafetyPlan.vue?vue&type=template&id=9ab3c6c6"
import script from "./constructionRelactionTaskSafetyPlan.vue?vue&type=script&lang=js"
export * from "./constructionRelactionTaskSafetyPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ab3c6c6')) {
      api.createRecord('9ab3c6c6', component.options)
    } else {
      api.reload('9ab3c6c6', component.options)
    }
    module.hot.accept("./constructionRelactionTaskSafetyPlan.vue?vue&type=template&id=9ab3c6c6", function () {
      api.rerender('9ab3c6c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionRelactionTaskSafetyPlan.vue"
export default component.exports